/* eslint-disable */
import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  Box,
  CircularProgress,
} from '@mui/material';
import { useAreas } from '../../hooks/useProductTimeline';

interface AreaFilterProps {
  selectedArea: string | null;
  onChange: (area: string | null) => void;
}

export const AreaFilter: React.FC<AreaFilterProps> = ({
  selectedArea,
  onChange,
}) => {
  const { data, isLoading, error } = useAreas();

  const handleChange = (event: SelectChangeEvent<string>) => {
    const value = event.target.value;
    onChange(value || null);
  };

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <CircularProgress size={20} />
        <span>Loading areas...</span>
      </Box>
    );
  }

  if (error) {
    return (
      <FormControl fullWidth size="small">
        <InputLabel>Area</InputLabel>
        <Select
          value=""
          label="Area"
          disabled
          error
        >
          <MenuItem value="">Error loading areas</MenuItem>
        </Select>
      </FormControl>
    );
  }

  const areas = data?.areas || [];

  return (
    <FormControl fullWidth size="small" data-testid="area-filter">
      <InputLabel id="area-filter-label">Area</InputLabel>
      <Select
        labelId="area-filter-label"
        id="area-filter"
        value={selectedArea || ''}
        onChange={handleChange}
        label="Area"
      >
        {areas.map((area) => (
          <MenuItem key={area} value={area}>
            {area}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
